<template>
  <div style="margin-bottom:65px; height: 100%;">
    <div v-for="(chart, index) in listCharts" :key="index" style="padding:10px">
      <h2>{{chart.title}}</h2>
      <h4>{{chart.subtitle}}</h4>
      <div class="text-center" v-if="chart.graphicType == 0">
        <pie-chart v-if="chart.data.length > 0" :chartdata="toPieChart(chart)" />
        <span v-if="chart.data.length == 0">Não há dados a serem mostrados para o período informado.</span>
      </div>
      <div style="width: 100%; overflow-x: auto;" v-if="chart.graphicType == 1">
        <div :style="{width: chart.width + 'px'}">
          <line-chart :styles="{height: `${chart.height}px`}" :chartdata="toLineAndBar(chart)" :options="options" />
        </div>
      </div>
      <div style="width: 100%; overflow-x: auto;" v-if="chart.graphicType == 2">
        <div :style="{width: chart.width + 'px'}">
          <bar-chart :styles="{height: `${chart.height}px`}" :chartdata="toLineAndBar(chart)" :options="options" />
        </div>
      </div>
    </div>
    <div @click="newKpi" v-if="listCharts.length == 0 && done" style="height:100%;" class="d-flex align-content-center flex-wrap text-center">
      <v-img
        src="img/graphic.png">
      </v-img>
      <span style="width:100%">Clique aqui e adicione o seu primeiro KPI</span>
    </div>
    <v-btn
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      class="btnPlus"
      @click="clickPlus"
    >
      <v-icon>
          mdi-plus
      </v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog.show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.message}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog.show = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmDelete.show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{dialogConfirmDelete.title}}
        </v-card-title>

        <v-card-text>
          {{dialogConfirmDelete.message}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogConfirmDelete.show = false"
          >
            Não
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteKpi"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirmUpdate.show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{dialogConfirmUpdate.title}}
        </v-card-title>

        <v-card-text>
          {{dialogConfirmUpdate.message}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogConfirmUpdate.show = false"
          >
            Não
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirmSaveKpi"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="crudKpi.show"
      persistent
    >
      <v-card style="padding:20px">
        <h2 class="text-center">KPIS</h2>
        <v-text-field
          v-model="crudKpi.title"
          label="Título"
          outlined
          clearable
          style="border-radius:12px"
        ></v-text-field>
        <v-datetime-picker 
          v-if="!crudKpi.actual"
          dateFormat="dd/MM/yyyy" 
          clearText="Limpar" 
          :textFieldProps=textFieldProps 
          :datePickerProps=datePickerProps 
          :timePickerProps=timePickerProps 
          label="Data Fim" 
          :datetime="crudKpi.endDate"
          v-model="crudKpi.endDate"> 
        </v-datetime-picker>
        <v-switch
          style="margin-top: 0px"
          label="Data Final Sempre Atual"
          v-model="crudKpi.actual"
          color="orange"
        ></v-switch>
        <simple-select 
          :model="crudKpi.period.periodSelected"
          label="Tipo Período"
          :items="crudKpi.period.listPeriods"
          v-on:valueChanged="changePeriod"
        ></simple-select>
        <v-radio-group
          v-model="crudKpi.typeKpi"
          label="Tipo de KPI:"
          style="margin-top: 0px;"
        >
          <v-radio
            label="Cliente"
            :value=1
          ></v-radio>
          <v-radio
            label="Contato"
            :value=2
          ></v-radio>
          <v-radio
            label="Prioridade"
            :value=3
          ></v-radio>
          <v-radio
            label="Área"
            :value=4
          ></v-radio>
          <v-radio
            label="Categoria"
            :value=5
          ></v-radio>
          <v-radio
            label="Assunto"
            :value=6
          ></v-radio>
          <v-radio
            label="Status"
            :value=7
          ></v-radio>
          <v-radio
            label="Nível de Suporte"
            :value=8
          ></v-radio>
          <v-radio
            label="Produto"
            :value=9
          ></v-radio>
          <v-radio
            label="Operador"
            :value=10
          ></v-radio>
        </v-radio-group>

        <multi-select 
          v-if="crudKpi.typeKpi == 1"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.clients.listClients]"
          label="Clientes"
          :model="crudKpi.clients.clientsSelected"
          v-on:valueChanged="changeMultiClient"
        ></multi-select>
        <simple-select 
          v-if="crudKpi.typeKpi == 2 || crudKpi.typeKpi == 9"
          :model="crudKpi.clients.clientSelected"
          label="Cliente"
          :items="crudKpi.clients.listClients"
          v-on:valueChanged="changeClient"
        ></simple-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 2"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.contacts.listContacts]"
          label="Contatos"
          :model="crudKpi.contacts.contactsSelected"
          v-on:valueChanged="changeMultiContact"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 3"
          :items="[{value: -1, text: 'TODAS'}, ...crudKpi.priorities.listPriorities]"
          label="Prioridades"
          :model="crudKpi.priorities.prioritiesSelected"
          v-on:valueChanged="changeMultiPriority"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 4"
          :items="[{value: -1, text: 'TODAS'}, ...crudKpi.areas.listAreas]"
          label="Áreas"
          :model="crudKpi.areas.areasSelected"
          v-on:valueChanged="changeMultiArea"
        ></multi-select>
        <simple-select 
          v-if="crudKpi.typeKpi == 5 || crudKpi.typeKpi == 6"
          :model="crudKpi.areas.areaSelected"
          label="Área"
          :items="crudKpi.areas.listAreas"
          v-on:valueChanged="changeArea"
        ></simple-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 5"
          :items="[{value: -1, text: 'TODAS'}, ...crudKpi.categories.listCategories]"
          label="Categorias"
          :model="crudKpi.categories.categoriesSelected"
          v-on:valueChanged="changeMultiCategory"
        ></multi-select>
        <simple-select 
          v-if="crudKpi.typeKpi == 6"
          :model="crudKpi.categories.categorySelected"
          label="Categoria"
          :items="crudKpi.categories.listCategories"
          v-on:valueChanged="changeCategory"
        ></simple-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 6"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.subjects.listSubjects]"
          label="Assuntos"
          :model="crudKpi.subjects.subjectsSelected"
          v-on:valueChanged="changeMultiSubject"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 7"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.status.listStatus]"
          label="Status"
          :model="crudKpi.status.statusSelected"
          v-on:valueChanged="changeMultiStatus"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 8"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.levels.listLevels]"
          label="Níveis de Suporte"
          :model="crudKpi.levels.levelsSelected"
          v-on:valueChanged="changeMultiLevel"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 9"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.products.listProducts]"
          label="Produtos"
          :model="crudKpi.products.productsSelected"
          v-on:valueChanged="changeMultiProduct"
        ></multi-select>
        <multi-select 
          v-if="crudKpi.typeKpi == 10"
          :items="[{value: -1, text: 'TODOS'}, ...crudKpi.operators.listOperators]"
          label="Operadores"
          :model="crudKpi.operators.operatorsSelected"
          v-on:valueChanged="changeMultiOperator"
        ></multi-select>
        <div v-if="
          (crudKpi.typeKpi == 1 && crudKpi.clients.clientsSelected.length == 1) ||
          (crudKpi.typeKpi == 2 && crudKpi.contacts.contactsSelected.length == 1) ||
          (crudKpi.typeKpi == 3 && crudKpi.priorities.prioritiesSelected.length == 1) ||
          (crudKpi.typeKpi == 4 && crudKpi.areas.areasSelected.length == 1) ||
          (crudKpi.typeKpi == 5 && crudKpi.categories.categoriesSelected.length == 1) ||
          (crudKpi.typeKpi == 6 && crudKpi.subjects.subjectsSelected.length == 1) ||
          (crudKpi.typeKpi == 7 && crudKpi.status.statusSelected.length == 1) ||
          (crudKpi.typeKpi == 8 && crudKpi.levels.levelsSelected.length == 1) ||
          (crudKpi.typeKpi == 9 && crudKpi.products.productsSelected.length == 1) ||
          (crudKpi.typeKpi == 10 && crudKpi.operators.operatorsSelected.length == 1) 
        ">
          <v-text-field
            type="number"
            v-model="crudKpi.width"
            label="Largura"
            outlined
            style="border-radius:12px"
          ></v-text-field>
          <v-text-field
            type="number"
            v-model="crudKpi.height"
            label="Altura"
            outlined
            style="border-radius:12px"
          ></v-text-field>
          <v-radio-group
            v-model="crudKpi.typeChart"
            label="Tipo de Gráfico:"
            style="margin-top: 0px;"
          >
            <v-radio
              label="Linha"
              :value=1
            ></v-radio>
            <v-radio
              label="Barra"
              :value=2
            ></v-radio>
          </v-radio-group>
        </div>
        <v-row align="center" justify="center" style="margin-top:20px; margin-bottom:0px">
          <v-btn
            :style="!crudKpi.edit ? `margin-right:20px` : `margin-right:5px`"
            @click="back"
          >
            Voltar
          </v-btn>
          <v-btn
            v-if="!crudKpi.edit"
            color="primary"
            style="color:white"
            @click="confirmSaveKpi"
          >
            Salvar
          </v-btn>
          <v-btn
            v-if="crudKpi.edit"
            color="#ff0000 !important"
            style="margin-right:5px; color:white"
            @click="deleteKpi"
          >
            Excluir
          </v-btn>
          <v-btn
            v-if="crudKpi.edit"
            color="primary"
            style="color:white"
            @click="updateKpi"
          >
            Alterar
          </v-btn>
        </v-row> 
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="dialogKpi" scrollable>
      <v-card>
        <v-card-title class="justify-center">Lista de KPIS</v-card-title>
        <v-divider></v-divider>
        <v-row align="center" justify="center" style="margin-top:20px; margin-bottom:20px">
          <v-btn
            style="margin-right:20px"
            @click="dialogKpi = false"
          >
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            style="color:white"
            @click="newKpi"
          >
            Novo
          </v-btn>
        </v-row> 
        <v-divider></v-divider>
        <v-card-text style="height: 500px;">
          <div v-for="(kpi, index) in listKpis" :key="index">
            <div @click="KpiDetail(kpi)">
              <sigCardInformation
                :subtitles="[{key: `Nome:`, value: kpi.title}]"
                :componentCurrent="component"
                :classCard="'pa-0'"
                :styleCard="'margin:10px'"
                :classSubtitle="'text-body-1'"
              ></sigCardInformation>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import SimpleSelect from '../../../components/selects/SimpleSelect';
  import MultiSelect from '../../../components/selects/MultiSelect';
  import LineChart from "../../../components/charts/Line";
  import BarChart from "../../../components/charts/Bar";
  import PieChart from "../../../components/charts/Pie";
  import CardInformation from "../../../components/card/CardInformation";
  import TextCard from "../../../components/card/TextCard";
  import CrudService from '../../../services/CrudService';
  import moment from 'moment';

  export default {

    components: {
      "line-chart": LineChart,
      "bar-chart": BarChart,
      "pie-chart": PieChart,
      "sigCardInformation": CardInformation,
      "simple-select": SimpleSelect,
      "multi-select": MultiSelect
    }, 

    data() {
      return {
        crudKpi:{
          idKpiEdit: null,
          edit: false,
          show: false,
          title: "",
          endDate: "",
          actual: true,
          period: {
            listPeriods: [
              {text: "DIA", value: 0},
              {text: "SEMANA", value: 1},
              {text: "MÊS", value: 2},
              {text: "ANO", value: 3}
            ],
            periodSelected: {text: "DIA", value: 0}
          },
          clients: {
            listClients: [],
            listClientsAllData: [],
            clientsSelected: [],
            clientSelected: null
          },
          contacts: {
            listContacts: [],
            contactsSelected: []
          },
          products: {
            listProducts: [],
            productsSelected: []
          },
          priorities: {
            listPriorities: [],
            prioritiesSelected: []
          },
          areas: {
            listAreas: [],
            areasSelected: [],
            areaSelected: null
          },
          categories: {
            listCategories: [],
            categoriesSelected: [],
            categorySelected: null
          },
          subjects: {
            listSubjects: [],
            subjectsSelected: []
          },
          status: {
            listStatus: [
              {text: 'TODOS', value: -1},
              {text: 'AGUARDANDO ATENDIMENTO', value: 10},
              {text: 'AGUARDANDO RETORNO CLIENTE', value: 20},
              {text: 'AVISO', value: 30},
              {text: 'CANCELADO', value: 40},
              {text: 'EM ATENDIMENTO', value: 50},
              {text: 'FINALIZADO PELO CLIENTE', value: 60},
              {text: 'FINALIZADO PELO OPERADOR', value: 70},
              {text: 'REABERTO PELO CLIENTE', value: 80},
              {text: 'REABERTO PELO OPERADOR', value: 90}
            ],
            statusSelected: []
          },
          levels: {
            listLevels: [
              {text: 'TODOS', value: -1},
              {text: 'NÍVEL 1', value: 1},
              {text: 'NÍVEL 2', value: 2},
              {text: 'NÍVEL 3', value: 3}
            ],
            levelsSelected: []
          },
          operators: {
            listOperators: [],
            operatorsSelected: []
          },
          width: 400,
          height: 250,
          typeChart: 1,
          typeKpi: 0
        },
        component: TextCard,
        dialogKpi: false,
        options: {
          tooltips: {
            intersect: false
          },
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              gridLines: {
                display:false
              }
            }],
            yAxes: [{
              gridLines: {
                display:false
              },
              ticks: {
                beginAtZero:true
              }   
            }]
          },
          legend:{
            display: false
          }
        },
        loginData: JSON.parse(localStorage.getItem("loginData")),
        dialog: {
          show: false,
          title: '',
          message: ''
        },
        dialogConfirmDelete: {
          show: false,
          title: '',
          message: '',
          click: ''
        },
        dialogConfirmUpdate: {
          show: false,
          title: '',
          message: '',
          click: ''
        },
        listCharts: [],
        done: false,
        listKpis: [],
        textFieldProps: {
          outlined: true,
          style:"border-radius:12px"
        },
        datePickerProps: {
          locale: "pt-br"
        },
        timePickerProps: {
          format:"24hr"
        },
      };
    },
    async created(){
      let canDemands = this.loginData.permissionAndMenu.find(permission => {
        return permission.menuId == 27
      });

      if(!(canDemands != null || this.loginData.userData.userType == 2))
        this.$router.push('menu');
      else
        await this.commomCreated();
    },
    methods: {
      async commomCreated(){
        let loader = this.$loading.show();

        try
        {
          let crudService = new CrudService();
          let resultAreas;

          let result = await crudService.get(`kpi/${this.loginData.userData.signatureId}/${this.loginData.userData.personId}`, this.loginData.token);

          if(result.status == 200){
            this.listCharts = result.data;
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultList = await crudService.get(`kpi/getListKpis/${this.loginData.userData.signatureId}/${this.loginData.userData.personId}`, this.loginData.token);

          if(resultList.status == 200) {
            this.listKpis = resultList.data;
          }
          else if(resultList.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultList.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultList.data[0];
            this.dialog.show = true;
          }
          else if(resultList.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          if(this.loginData.userData.userType == 1){
            let resultClients = await crudService.get(`comboDemands/getComboClients/${this.loginData.userData.personId}`, this.loginData.token);
            
            if(resultClients.status == 200){
              this.crudKpi.clients.listClients = resultClients.data.map(client => {
                return {
                  text: client.clientName,
                  value: client.clientId 
                }
              });

              this.crudKpi.clients.listClientsAllData = resultClients.data;
            }
            else if(resultClients.status == 401){
              localStorage.removeItem("loginData");
              this.$router.push({name: 'Login', params: {logout: true}});
            }
            else if(resultClients.status == 400){
              this.dialog.title = "Erro";
              this.dialog.message = resultClients.data[0];
              this.dialog.show = true;
            }
            else if(resultClients.status != 204){
              this.dialog.title = "Erro";
              this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
              this.dialog.show = true;
            }

            resultAreas = await crudService.get(`comboDemands/getComboAreaFilter/${this.loginData.userData.personId}`, this.loginData.token);
          }
          else{
            this.crudKpi.clients.listClients = {text: this.loginData.userData.clientName, value: this.loginData.userData.clientId};
            resultAreas = await crudService.get(`comboDemands/getComboArea?clientHelpDeskId=${this.loginData.userData.clientHelpDeskId}&personId=${this.loginData.userData.personId}&userType=2`, this.loginData.token);
          }

          if(resultAreas.status == 200){
            this.crudKpi.areas.listAreas = resultAreas.data.map(area => {
              return {
                text: area.areaName,
                value: area.areaId
              }
            });
          }
          else if(resultAreas.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultAreas.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultAreas.data[0];
            this.dialog.show = true;
          }
          else if(resultAreas.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultPriority = await crudService.get(`comboDemands/getComboPriority/${this.loginData.userData.signatureId}`, this.loginData.token);

          if(resultPriority.status == 200){
            this.crudKpi.priorities.listPriorities = resultPriority.data.map(priority => {
              return {
                text: priority.description,
                value: priority.priorityId 
              }
            });
          }
          else if(resultPriority.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultPriority.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultPriority.data[0];
            this.dialog.show = true;
          }
          else if(resultPriority.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultOperators = await crudService.get(`comboDemands/getComboOperatorsFilter/${this.loginData.userData.signatureId}`, this.loginData.token);

          if(resultOperators.status == 200){
            this.crudKpi.operators.listOperators = resultOperators.data.map(operator => {
              return {
                text: operator.operatorName,
                value: operator.operatorId  
              }
            });
          }
          else if(resultOperators.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultOperators.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultOperators.data[0];
            this.dialog.show = true;
          }
          else if(resultOperators.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();

          this.done = true;
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;
        }
      },
      toLineAndBar(chartData){
        let labels = [];
        let data = [];

        for(let i = 0; i < chartData.data.length; i++){
          labels.push(chartData.data[i].x);
          data.push(chartData.data[i].y);
        }
        
        return {
          labels: labels,
          datasets: [
            { 
              label: "Quantidade",
              backgroundColor: this.$vuetify.theme.defaults.light.primary,
              data: data,
              pointBorderColor: "black", 
              pointBackgroundColor: "white", 
              pointBorderWidth: 1, 
              pointRadius: 5
            }
          ]
        }
      },
      toPieChart(chartData){
        let labels = [];
        let backgroundColor = [];
        let data = [];

        for(let i = 0; i < chartData.data.length; i++){
          labels.push(chartData.data[i].x);
          backgroundColor.push(chartData.colorScale[i]);
          data.push(chartData.data[i].y);
        }
        return {
          labels: labels,
          datasets: [{
            backgroundColor: backgroundColor,
            data: data
          }]
        }
      },
      async KpiDetail(kpiSelected){
        let loader = this.$loading.show();

          try
          {
            let crudService = new CrudService();

            let kpi = await crudService.get(`kpi/getKpi/${kpiSelected.kpiId}`, this.loginData.token);
            
            if(kpi.status == 200){
              let selected = kpi.data.clients ? 1 : kpi.data.contact ? 2 : kpi.data.priority ? 3 : kpi.data.sector ? 4 : kpi.data.category ? 5 : kpi.data.subject ? 6 : kpi.data.status ? 7 : kpi.data.supportLevel ? 8 : kpi.data.product ? 9 : 10;
              
              this.crudKpi.title = kpi.data.title;
              this.crudKpi.endDate = kpi.data.endDate != null ? moment(kpi.data.endDate).format("DD/MM/YYYY HH:mm") : '';
              this.crudKpi.actual = kpi.data.today;
              this.crudKpi.period.periodSelected = this.crudKpi.period.listPeriods.find(period => { return period.value == kpi.data.typePeriod });
              this.crudKpi.width = kpi.data.width != null ? kpi.data.width : 0;
              this.crudKpi.height = kpi.data.height != null ? kpi.data.width : 0;
              this.crudKpi.typeChart = kpi.data.graphicType;
              this.crudKpi.typeKpi = selected;

              let arrCombos = kpi.data.idsCombo.split(";");

              if(selected == 1){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.clients.clientsSelected = [{text: "TODOS", value: -1}];
                }

                this.crudKpi.clients.clientsSelected = [...this.crudKpi.clients.clientsSelected, ...this.crudKpi.clients.listClients.filter(client => { return list.includes(client.value) }) ];
              }
              else if(selected == 2){
                let list = arrCombos[1].split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.contacts.contactsSelected = [{text: "TODOS", value: -1}];
                }
                
                await this.changeClient(this.crudKpi.clients.listClients.find(client => { return client.value == parseInt(arrCombos[0]) }));
                
                this.crudKpi.contacts.contactsSelected = [...this.crudKpi.contacts.contactsSelected, ...this.crudKpi.contacts.listContacts.filter(contact => { return list.includes(contact.value) }) ];
              }
              else if(selected == 3){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.priorities.prioritiesSelected = [{text: "TODAS", value: -1}];
                }

                this.crudKpi.priorities.prioritiesSelected = [...this.crudKpi.priorities.prioritiesSelected, ...this.crudKpi.priorities.listPriorities.filter(priority => { return list.includes(priority.value) }) ];
              }
              else if(selected == 4){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.areas.areasSelected = [{text: "TODAS", value: -1}];
                }

                this.crudKpi.areas.areasSelected = [...this.crudKpi.areas.areasSelected, ...this.crudKpi.areas.listAreas.filter(area => { return list.includes(area.value) }) ];
              }
              else if(selected == 5){
                let list = arrCombos[1].split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.categories.categoriesSelected = [{text: "TODAS", value: -1}];
                }
                
                await this.changeArea(this.crudKpi.areas.listAreas.find(area => { return area.value == parseInt(arrCombos[0]) }));
                
                this.crudKpi.categories.categoriesSelected = [...this.crudKpi.categories.categoriesSelected, ...this.crudKpi.categories.listCategories.filter(category => { return list.includes(category.value) }) ];
              }
              else if(selected == 6){
                let list = arrCombos[2].split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.subjects.subjectsSelected = [{text: "TODOS", value: -1}];
                }
                
                await this.changeArea(this.crudKpi.areas.listAreas.find(area => { return area.value == parseInt(arrCombos[0]) }));
                await this.changeCategory(this.crudKpi.categories.listCategories.find(category => { return category.value == parseInt(arrCombos[1]) }));
                
                this.crudKpi.subjects.subjectsSelected = [...this.crudKpi.subjects.subjectsSelected, ...this.crudKpi.subjects.listSubjects.filter(subject => { return list.includes(subject.value) }) ];
              }
              else if(selected == 7){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.status.statusSelected = [{text: "TODOS", value: -1}];
                }

                this.crudKpi.status.statusSelected = [...this.crudKpi.status.statusSelected, ...this.crudKpi.status.listStatus.filter(status => { return list.includes(status.value) }) ];
              }
              else if(selected == 8){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.levels.levelsSelected = [{text: "TODOS", value: -1}];
                }

                this.crudKpi.levels.levelsSelected = [...this.crudKpi.levels.levelsSelected, ...this.crudKpi.levels.listLevels.filter(level => { return list.includes(level.value) }) ];
              }
              else if(selected == 9){
                let list = arrCombos[1].split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.products.productsSelected = [{text: "TODOS", value: -1}];
                }
                
                await this.changeClient(this.crudKpi.clients.listClients.find(client => { return client.value == parseInt(arrCombos[0]) }));
                
                this.crudKpi.products.productsSelected = [...this.crudKpi.products.productsSelected, ...this.crudKpi.products.listProducts.filter(product => { return list.includes(product.value) }) ];
              }
              else if(selected == 10){
                let list = kpi.data.idsCombo.split`,`.map(x=>+x);
                
                if(list.includes(-1)){
                  this.crudKpi.operators.operatorsSelected = [{text: "TODOS", value: -1}];
                }
              
                this.crudKpi.operators.operatorsSelected = [...this.crudKpi.operators.operatorsSelected, ...this.crudKpi.operators.listOperators.filter(operator => { return list.includes(operator.value) }) ];                
              }

              document.getElementsByTagName('body')[0].className='noscroll'; 
              this.crudKpi.show = true;
              this.crudKpi.idKpiEdit = kpiSelected.kpiId;
              this.crudKpi.edit = true;
            }
            else if(kpi.status == 401){
              localStorage.removeItem("loginData");
              this.$router.push({name: 'Login', params: {logout: true}});
            }
            else if(kpi.status == 400){
              this.dialog.title = "Erro";
              this.dialog.message = kpi.data[0];
              this.dialog.show = true;
            }
            else if(kpi.status != 204){
              this.dialog.title = "Erro";
              this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
              this.dialog.show = true;
            }

            loader.hide();
          }
          catch
          {
            loader.hide();
            this.dialog.title = "Erro";
            this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
            this.dialog.show = true;
          }
      },
      changePeriod(period){
        if(typeof period === 'object'){
          this.crudKpi.period.periodSelected = period;
        }
        else{
          this.crudKpi.period.periodSelected = {text: "DIA", value: 0}
        }
      },
      changeMultiClient(listClients){
        this.crudKpi.clients.clientsSelected = listClients;
      },
      async changeClient(client){
        if(typeof client === 'object'){
          let loader = this.$loading.show();

          try
          {
            let crudService = new CrudService();

            this.crudKpi.clients.clientSelected = client;

            let clientInList = this.crudKpi.clients.listClientsAllData.find((cli) => {
              return cli.clientId == client.value;
            });
            
            if(client.value != null){
              let resultContacts;
              
              if(this.loginData.userData.userType == 1){
                resultContacts = await crudService.get(`comboDemands/getComboContact/${clientInList.clientHelpDeskId}`, this.loginData.token);
              }
              else{
                resultContacts = await crudService.get(`comboDemands/getComboContact/${client.value}`, this.loginData.token);
              }
              
              if(resultContacts.status == 200){
                this.crudKpi.contacts.listContacts = [
                  ...resultContacts.data.map(contact => {
                    return {
                      text: contact.contactName,
                      value: contact.contactId 
                    }
                  })
                ];

                this.crudKpi.contacts.contactsSelected = [];
              }
              else if(resultContacts.status == 401){
                localStorage.removeItem("loginData");
                this.$router.push({name: 'Login', params: {logout: true}});
              }
              else if(resultContacts.status == 400){
                this.dialog.title = "Erro";
                this.dialog.message = resultContacts.data[0];
                this.dialog.show = true;
              }
              else if(resultContacts.status != 204){
                this.dialog.title = "Erro";
                this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                this.dialog.show = true;
              }

              let resultProducts = await crudService.get(`comboDemands/getComboProduct?clientId=${client.value}&productsOrder=${this.loginData.productsOrder == null ? false : this.loginData.productsOrder}`, this.loginData.token);
              
              if(resultProducts.status == 200){
                this.crudKpi.products.listProducts = [
                  ...resultProducts.data.map(p => {
                    let labelEquipment = "";
                    if(p.internalCode != null && p.internalCode != "" && p.productName != null && p.productName != ""){
                      labelEquipment = `${p.internalCode} - ${p.productName}`;
                    }
                    else if((p.internalCode == null || p.internalCode == "") && (p.productName != null && p.productName != "")){
                      labelEquipment = `${p.productName}`;
                    }
                    else if((p.internalCode != null && p.internalCode != "") && (p.productName == null || p.productName == "")){
                      labelEquipment = `${p.internalCode}`;
                    }

                    return {
                      text: labelEquipment,
                      value: p.productId 
                    }
                  })
                ]

                this.crudKpi.products.productsSelected = [];
              }
              else if(resultProducts.status == 401){
                localStorage.removeItem("loginData");
                this.$router.push({name: 'Login', params: {logout: true}});
              }
              else if(resultProducts.status == 400){
                this.dialog.title = "Erro";
                this.dialog.message = resultProducts.data[0];
                this.dialog.show = true;
              }
              else if(resultProducts.status != 204){
                this.dialog.title = "Erro";
                this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                this.dialog.show = true;
              }
            }
            else{
              this.crudKpi.clients.clientSelected = null;
              this.crudKpi.contacts.listContacts = [];
              this.crudKpi.contacts.contactsSelected = [];
            }

            loader.hide();
          }
          catch
          {
            loader.hide();
            this.dialog.title = "Erro";
            this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
            this.dialog.show = true;
          }
        }
        else{
          this.crudKpi.clients.clientSelected = null;
          this.crudKpi.contacts.listContacts = [];
          this.crudKpi.contacts.contactsSelected = [];
        }
      },
      changeMultiContact(listContacts){
        this.crudKpi.contacts.contactsSelected = listContacts;
      },
      changeMultiPriority(listPriorities){
        this.crudKpi.priorities.prioritiesSelected = listPriorities;
      },
      changeMultiArea(listAreas){
        this.crudKpi.areas.areasSelected = listAreas;
      },
      async changeArea(area){
        if(typeof area === 'object'){
          let loader = this.$loading.show();

          try
          {
            this.crudKpi.areas.areaSelected = area;
            let crudService = new CrudService();

            let resultCategory = await crudService.get(`comboDemands/getComboCategory/${area.value}`, this.loginData.token);
            
            if(resultCategory.status == 200){
              this.crudKpi.subjects.listSubjects = [];
              this.crudKpi.subjects.subjectsSelected = [];
              
              this.crudKpi.categories.listCategories = resultCategory.data.map(category => {
                return {
                  text: category.categoryName,
                  value: category.categoryId
                }
              });
            }
            else if(resultCategory.status == 401){
              localStorage.removeItem("loginData");
              this.$router.push({name: 'Login', params: {logout: true}}); 
            }
            else if(resultCategory.status == 400){
              this.dialog.title = "Erro";
              this.dialog.message = resultCategory.data[0];
              this.dialog.show = true;
            }
            else if(resultCategory.status != 204){
              this.dialog.title = "Erro";
              this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
              this.dialog.show = true;
            }

            loader.hide();
          }
          catch
          {
            loader.hide();
            this.dialog.title = "Erro";
            this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
            this.dialog.show = true;
          }
        }
        else{
          this.crudKpi.areas.areaSelected = null;
          this.crudKpi.categories.listCategories = [];
          this.crudKpi.subjects.listSubjects = [];
          this.crudKpi.categories.categoriesSelected = [];
          this.crudKpi.subjects.subjectsSelected = [];
        }

        this.crudKpi.categories.categorySelected = null;
      },
      changeMultiCategory(listCategories){
        this.crudKpi.categories.categoriesSelected = listCategories;
      },
      async changeCategory(category){
        if(typeof category === 'object'){
          let loader = this.$loading.show();

          try
          {
            this.crudKpi.categories.categorySelected = category;

            let crudService = new CrudService();

            let resultSubject = await crudService.get(`comboDemands/getComboSubject/${category.value}`, this.loginData.token);
            
            if(resultSubject.status == 200){
              this.crudKpi.subjects.listSubjects = [];
              this.crudKpi.subjects.subjectsSelected = [];

              this.crudKpi.subjects.listSubjects = resultSubject.data.map(subject => {
                return {
                  text: subject.title,
                  value: subject.subjectId
                }
              });
            }
            else if(resultSubject.status == 401){
              localStorage.removeItem("loginData");
              this.$router.push({name: 'Login', params: {logout: true}});
            }
            else if(resultSubject.status == 400){
              this.dialog.title = "Erro";
              this.dialog.message = resultSubject.data[0];
              this.dialog.show = true;
            }
            else if(resultSubject.status != 204){
              this.dialog.title = "Erro";
              this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
              this.dialog.show = true;
            }
            loader.hide();
          }
          catch
          {
            loader.hide();
            this.dialog.title = "Erro";
            this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
            this.dialog.show = true;
          }
        }
        else{
          this.crudKpi.categories.categorySelected = null;
          this.crudKpi.subjects.listSubjects = [];
          this.crudKpi.subjects.subjectsSelected = [];
        }
      },
      changeMultiSubject(listSubjects){
        this.crudKpi.subjects.subjectsSelected = listSubjects;
      },
      changeMultiStatus(listStatus){
        this.crudKpi.status.statusSelected = listStatus;
      },
      changeMultiLevel(listLevels){
        this.crudKpi.levels.levelsSelected = listLevels;
      },
      changeMultiProduct(listProducts){
        this.crudKpi.products.productsSelected = listProducts;
      },
      changeMultiOperator(listOperators){
        this.crudKpi.operators.operatorsSelected = listOperators;
      },
      async confirmSaveKpi(){
        let loader = this.$loading.show();
        
        try
        {
          let idsCombo = "";
          let graphicType = 0;
          
          if(this.crudKpi.typeKpi == 1){
              
            if(this.crudKpi.clients.clientsSelected.length > 0){
              idsCombo = this.crudKpi.clients.clientsSelected.map(client => { return client.value }).join();
            }

            if(this.crudKpi.clients.clientsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 2){
              
            if(this.crudKpi.contacts.contactsSelected.length > 0){
              let clientInList = this.crudKpi.clients.listClientsAllData.find((cli) => {
                return cli.clientId == this.crudKpi.clients.clientSelected.value;
              });

              idsCombo = `${clientInList.clientHelpDeskId};${this.crudKpi.contacts.contactsSelected.map(contact => { return contact.value }).join()}`;
            }

            if(this.crudKpi.contacts.contactsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 3){
              
            if(this.crudKpi.priorities.prioritiesSelected.length > 0){
              idsCombo = this.crudKpi.priorities.prioritiesSelected.map(priority => { return priority.value }).join();
            }

            if(this.crudKpi.priorities.prioritiesSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 4){
              
            if(this.crudKpi.areas.areasSelected.length > 0){    
              idsCombo = this.crudKpi.areas.areasSelected.map(area => { return area.value }).join();
            }

            if(this.crudKpi.areas.areasSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 5){

            if(this.crudKpi.categories.categoriesSelected.length > 0){
              idsCombo = `${this.crudKpi.areas.areaSelected.value};${this.crudKpi.categories.categoriesSelected.map(category => { return category.value }).join()}`;
            }

            if(this.crudKpi.categories.categoriesSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 6){
              
            if(this.crudKpi.subjects.subjectsSelected.length > 0){
              idsCombo = `${this.crudKpi.areas.areaSelected.value};${this.crudKpi.categories.categorySelected.value};${this.crudKpi.subjects.subjectsSelected.map(subject => { return subject.value }).join()}`;
            }

            if(this.crudKpi.subjects.subjectsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 7){
              
            if(this.crudKpi.status.statusSelected.length > 0){
              idsCombo = this.crudKpi.status.statusSelected.map(status => { return status.value }).join();
            }

            if(this.crudKpi.status.statusSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 8){
              
            if(this.crudKpi.levels.levelsSelected.length > 0){
              idsCombo = this.crudKpi.levels.levelsSelected.map(level => { return level.value }).join();
            }

            if(this.crudKpi.levels.levelsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 9){
              
            if(this.crudKpi.products.productsSelected.length > 0){
              idsCombo = `${this.crudKpi.clients.clientSelected.value};${this.crudKpi.products.productsSelected.map(product => { return product.value }).join()}`;
            }

            if(this.crudKpi.products.productsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          else if(this.crudKpi.typeKpi == 10){
              
            if(this.crudKpi.operators.operatorsSelected.length > 0){
              idsCombo = this.crudKpi.operators.operatorsSelected.map(operator => {return operator.value}).join();
            }

            if(this.crudKpi.operators.operatorsSelected.length == 1){
              if(this.crudKpi.typeChart == 0){
                graphicType = 1;
              }
              else{
                graphicType = this.crudKpi.typeChart;
              }
            }
          }
          
          let createKpi = {
            kpiId: this.crudKpi.idKpiEdit == null ? 0 : this.crudKpi.idKpiEdit,
            personId: this.loginData.userData.personId,
            signatureId: this.loginData.userData.signatureId,
            idsCombo,
            clients: this.crudKpi.typeKpi == 1 ? true : false,
            contact: this.crudKpi.typeKpi == 2 ? true : false,
            priority: this.crudKpi.typeKpi == 3 ? true : false,
            sector: this.crudKpi.typeKpi == 4 ? true : false,
            category: this.crudKpi.typeKpi == 5 ? true : false,
            subject: this.crudKpi.typeKpi == 6 ? true : false,
            status: this.crudKpi.typeKpi == 7 ? true : false,
            supportLevel: this.crudKpi.typeKpi == 8 ? true : false,
            product: this.crudKpi.typeKpi == 9 ? true : false,
            operator: this.crudKpi.typeKpi == 10 ? true : false,
            today: this.crudKpi.actual,          
            graphicType,
            typePeriod: this.crudKpi.period.periodSelected.value,
            endDate: this.crudKpi.endDate == '' ? null : moment(this.crudKpi.endDate, "DD/MM/YYYY HH:mm").format("YYYY/MM/DD HH:mm"),
            height: this.crudKpi.height,
            width: this.crudKpi.width,
            title: this.crudKpi.title
          };
          
          let crudService = new CrudService();

          let result; 
          let action = "";
          
          if(this.crudKpi.idKpiEdit == null){
              result = await crudService.post(`kpi`, createKpi, this.loginData.token);
              action = "Criado";
          }
          else{
              result = await crudService.put(`kpi`, createKpi, this.loginData.token);
              action = "Alterado";
              this.dialogConfirmUpdate.show = false;
          }

          if(result.status == 200){
            this.dialog.title = "Sucesso";
            this.dialog.message = `KPI ${action} com Sucesso.`;
            
            loader.hide();
            await this.commomCreated();

            this.dialog.show = true;
            document.body.removeAttribute("class","noscroll");
            this.crudKpi.show = false;
            this.crudKpi.idKpiEdit = null;
            this.crudKpi.edit = false;
            this.dialogKpi = false;
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }
          loader.hide();
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;
        }
      },
      clickPlus(){
        if(this.listKpis.length > 0)
          this.dialogKpi = true;
        else{
          this.newKpi();
        }
      },
      newKpi(){
        this.crudKpi.title = "";
        this.crudKpi.endDate = "";
        this.crudKpi.actual = true;
        this.crudKpi.period.periodSelected = {text: "DIA", value: 0};
        this.crudKpi.clients.clientsSelected = [];
        this.crudKpi.clients.clientSelected = null;
        this.crudKpi.contacts.contactsSelected = [];
        this.crudKpi.products.productsSelected = [];
        this.crudKpi.priorities.prioritiesSelected = [];
        this.crudKpi.areas.areasSelected = [];
        this.crudKpi.areas.areaSelected = null;
        this.crudKpi.categories.categoriesSelected = [];
        this.crudKpi.categories.categorySelected = null;
        this.crudKpi.subjects.subjectsSelected = [];
        this.crudKpi.status.statusSelected = [];
        this.crudKpi.levels.levelsSelected = [];
        this.crudKpi.operators.operatorsSelected = [];
        this.crudKpi.width = 400;
        this.crudKpi.height = 250;
        this.crudKpi.typeChart = 1;
        this.crudKpi.typeKpi = 0;

        document.getElementsByTagName('body')[0].className='noscroll'; 
        this.crudKpi.show = true;
        this.crudKpi.actual = true;
      },
      back(){
        document.body.removeAttribute('class','noscroll'); 
        this.crudKpi.show = false;
        this.crudKpi.idKpiEdit = null;
        this.crudKpi.edit = false;
      },
      updateKpi(){
        this.dialogConfirmUpdate.show = true;
        this.dialogConfirmUpdate.title = "Alteração";
        this.dialogConfirmUpdate.message = "Confirma Alteração do KPI?";
      },
      deleteKpi(){
        this.dialogConfirmDelete.show = true;
        this.dialogConfirmDelete.title = "Exclusão";
        this.dialogConfirmDelete.message = "Confirma Exclusão do KPI?";
      },
      async confirmDeleteKpi(){
        let loader = this.$loading.show();

        try
        {
          let crudService = new CrudService();

          let result = await crudService.delete(`kpi/${this.crudKpi.idKpiEdit}`, this.loginData.token);
            
          this.dialogConfirmDelete.show = false;

          if(result.status == 200){
            this.dialog.title = "Sucesso";
            this.dialog.message = "KPI Excluído com Sucesso.";
            loader.hide();
            
            await this.commomCreated();
            document.body.removeAttribute("class","noscroll");
            this.crudKpi.show = false;
            this.dialogKpi = false;
            this.dialog.show = true;
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();
        }
        catch
        {
          loader.hide();
        }
      }
    },
  };
</script>
<style>
.btnPlus {
  margin-bottom:50px;
}
.noscroll{
  position: fixed;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;
}
/* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
  .btnPlus {
    margin-bottom:80px;
  }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .btnPlus {
    margin-bottom:80px;
  }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
  .btnPlus {
    margin-bottom:80px;
  }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
  .btnPlus {
    margin-bottom:80px;
  }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
  .btnPlus {
    margin-bottom:80px;
  }
}
</style>